import Prize from '@/models/Prize'

const state = {
    isLoaded: false,

    prizes: []
}

const getters = {
    isLoaded: state => state.isLoaded,
    prizes  : state => state.prizes,
}

const mutations = {
    SET_PRIZES_DATA: (state, data) => (state.prizes = data),
    SET_IS_LOADED  : (state, value = false) => (state.isLoaded = value),
}

const actions = {
    async getPrizeData({ commit }) {
        const response = await Prize.list()

        if(!response) return
        
        commit('SET_PRIZES_DATA', response)
        commit('SET_IS_LOADED', true)
    },
}

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
}
